import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HoldingType, HoldingTypeCategoryEnum } from 'taxtank-core';

/**
 * Dialog component with holding type form
 */
@Component({
  selector: 'app-holding-type-form-dialog',
  templateUrl: './holding-type-form-dialog.component.html',
  styleUrls: ['./holding-type-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HoldingTypeFormDialogComponent {
  public holdingType = inject<HoldingType>(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<HoldingTypeFormDialogComponent>);

  categories: typeof HoldingTypeCategoryEnum = HoldingTypeCategoryEnum;
  category: HoldingTypeCategoryEnum = HoldingTypeCategoryEnum.STOCK;
}
